const ENV = process.env.NODE_ENV;

export const msalConfig: any = {
  auth: {
    clientId: "934bb003-5c75-4c40-b8b8-cd281d23c804",
    authority: "https://login.microsoftonline.com/claimsconf.onmicrosoft.com",
    redirectUri: ENV === "development" ? "http://localhost:3000/admin_login" : window.location.origin + "/admin_login",
    postLogoutRedirectUri:
      ENV === "development" ? "http://localhost:3000/admin_login" : window.location.origin + "/admin_login",
    clientCapabilities: ["CP1"],
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["api://b883e280-fb53-4e4a-ab9c-e19428e0bfd2/ReadWrite"],
};
